import React, { useState, useEffect, useRef } from "react";
import { MapContainer, TileLayer, ZoomControl } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import AddMarkerOnClick from "./AddMarkerOnClick";
import CustomMarker from "./CustomMarker";
import AddressSearch from "./AddressSearch";
import "../../styles/MapContainer.css";

const Alerta = ({ markers = [], handleMarkerClick, handleAddMarker, onAddressSelect, onCoordinatesSelect, onCloseModal }) => {
  const [isLocating, setIsLocating] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const mapRef = useRef(null);

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      setIsFullscreen(true);
    } else {
      document.exitFullscreen();
      setIsFullscreen(false);
    }
  };

  const handleAddressSelect = (addressData) => {
    console.log("📍 DIRECCIÓN SELECCIONADA EN MAPCONTAINER:", addressData);
    console.log("📍 Coordenadas:", addressData.lat, addressData.lng);
    console.log("📍 mapRef.current disponible:", !!mapRef.current);
    
    if (onAddressSelect) {
      console.log("📍 Llamando a onAddressSelect del padre");
      onAddressSelect(addressData);
    }
    
    // Centrar el mapa en la ubicación seleccionada con animación suave
    if (mapRef.current) {
      console.log("🗺️ CENTRANDO MAPA en:", addressData.lat, addressData.lng);
      
      // Forzar el centrado del mapa
      try {
        mapRef.current.setView([addressData.lat, addressData.lng], 17, {
          animate: true,
          duration: 1.5
        });
        console.log("✅ Mapa centrado exitosamente");
      } catch (error) {
        console.error("❌ Error centrando mapa:", error);
      }
      
      // Agregar marcador temporal en la ubicación seleccionada
      if (handleAddMarker) {
        console.log("📍 AGREGANDO MARCADOR en:", addressData.lat, addressData.lng);
        try {
          handleAddMarker(addressData.lat, addressData.lng);
          console.log("✅ Marcador agregado exitosamente");
        } catch (error) {
          console.error("❌ Error agregando marcador:", error);
        }
      } else {
        console.warn("⚠️ handleAddMarker no está disponible");
      }
    } else {
      console.error("❌ mapRef.current NO está disponible");
      console.error("❌ Estado del mapa:", mapRef);
    }
  };

  const handleCoordinatesSelect = (lat, lng) => {
    console.log("📍 Coordenadas seleccionadas manualmente:", lat, lng);
    if (onCoordinatesSelect) {
      onCoordinatesSelect(lat, lng);
    }
  };

  const handleMyLocation = () => {
    setIsLocating(true);
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          // Centrar el mapa en la ubicación actual con animación
          if (mapRef.current) {
            mapRef.current.setView([latitude, longitude], 17, {
              animate: true,
              duration: 1.5
            });
          }
          setIsLocating(false);
        },
        (error) => {
          console.error('Error obteniendo ubicación:', error);
          setIsLocating(false);
        }
      );
    } else {
      setIsLocating(false);
    }
  };

  // Función para obtener referencia del mapa
  const onMapReady = (map) => {
    console.log("🗺️ MAPA LISTO - onMapReady llamado");
    console.log("🗺️ Instancia del mapa:", map);
    console.log("🗺️ Métodos disponibles:", Object.keys(map));
    
    mapRef.current = map;
    
    // Verificar que el mapa esté funcionando
    if (map && map.setView) {
      console.log("✅ Mapa configurado correctamente con setView");
    } else {
      console.error("❌ Mapa no tiene método setView");
    }
    
    // Hacer el mapa accesible globalmente
    window.mapInstance = map;
    console.log("🗺️ Mapa guardado en window.mapInstance");
  };

  return (
    <div className={`map-container ${isFullscreen ? 'fullscreen' : ''}`}>
      {/* Buscador de direcciones FUERA del mapa */}
      <div className="map-search-container">
        <AddressSearch 
          onAddressSelect={handleAddressSelect}
          onCoordinatesSelect={handleCoordinatesSelect}
          onCloseModal={onCloseModal}
        />
      </div>

      {/* Controles del mapa */}
      <div className="map-controls">
        <div className="map-controls-right">
          <button 
            className="control-btn fullscreen-btn" 
            onClick={toggleFullscreen}
            title={isFullscreen ? "Salir de pantalla completa" : "Pantalla completa"}
            type="button"
          >
            <i className={`fas ${isFullscreen ? 'fa-compress' : 'fa-expand'}`}></i>
          </button>
          
          <button 
            className={`control-btn location-btn ${isLocating ? 'loading' : ''}`} 
            onClick={handleMyLocation}
            title="Mi ubicación actual"
            disabled={isLocating}
            type="button"
          >
            <i className="fas fa-crosshairs"></i>
          </button>
        </div>
      </div>

      {/* Contenedor del mapa */}
      <div className="map-wrapper">
        <MapContainer 
          center={{ lat: -12.117939985496957, lng: -77.02892645376073 }} 
          zoom={17} 
          className="map-leaflet"
          whenCreated={onMapReady}
          zoomControl={true} // Activar controles de zoom
        >
          <TileLayer 
            attribution="SUB GERENCIA DE MOVILIDAD URBANA Y SEGURIDAD VIAL" 
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" 
          />
          
          <AddMarkerOnClick handleAddMarker={handleAddMarker} />
          {markers.map((marker) => (
            <CustomMarker 
              key={marker.id} 
              marker={marker} 
              handleMarkerClick={handleMarkerClick} 
            />
          ))}
        </MapContainer>
      </div>

      {/* Información de ayuda */}
      <div className="map-help">
        <div className="help-item">
          <i className="fas fa-search"></i>
          <span>Busca una dirección o haz clic en el mapa</span>
        </div>
        <div className="help-item">
          <i className="fas fa-map-marker-alt"></i>
          <span>Haz clic para marcar la ubicación</span>
        </div>
      </div>
    </div>
  );
};

export default Alerta;

